var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as PIXI from 'pixi.js';
import { DEFORMER_MANIP_ENUM } from "./enums";
import { createDeformerOfType } from "./factory";
var VERBOSE = false;
/**
 * Manages the deformers for a single object
 */
var DeformerStack = /** @class */ (function (_super) {
    __extends(DeformerStack, _super);
    function DeformerStack(parent, settings) {
        if (settings === void 0) { settings = { uvs: false }; }
        var _this = _super.call(this) || this;
        _this._parent = undefined;
        _this._uvs = true;
        _this._deformers = [];
        _this._parent = parent;
        if ('uvs' in settings) {
            VERBOSE && console.log('uvs', settings.uvs);
            _this._uvs = settings.uvs;
        }
        return _this;
    }
    Object.defineProperty(DeformerStack.prototype, "uvs", {
        get: function () {
            return this._uvs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeformerStack.prototype, "dirty", {
        /**
         * What does it mean for the deformer stack to be dirty?
         */
        get: function () {
            return this.deformers.some(function (deformer) { return deformer.dirty; });
        },
        enumerable: false,
        configurable: true
    });
    DeformerStack.prototype.update = function () {
        VERBOSE && console.log('deformerStack update');
        this.deformers.forEach(function (deformer) { return deformer.update(); });
    };
    Object.defineProperty(DeformerStack.prototype, "matrixDeformers", {
        get: function () {
            return this._deformers.filter(function (deformer) { return deformer.deformerType.includes(DEFORMER_MANIP_ENUM.MATRIX); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeformerStack.prototype, "vertexDeformers", {
        get: function () {
            return this._deformers.filter(function (deformer) { return deformer.deformerType.includes(DEFORMER_MANIP_ENUM.VERTEX); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeformerStack.prototype, "deformers", {
        get: function () {
            return this._deformers;
        },
        enumerable: false,
        configurable: true
    });
    /* Add a deformer of a specific type. */
    DeformerStack.prototype.addDeformerOfType = function (deformerType) {
        var deformer = createDeformerOfType(deformerType);
        this.addDeformer(deformer);
        return deformer;
    };
    /* Add a deformer. */
    DeformerStack.prototype.addDeformer = function (deformer) {
        deformer._deformerStack = this;
        this._deformers.push(deformer);
        deformer.update();
        // TODO: fix me
        this.emit('deformerAdded');
    };
    DeformerStack.prototype.addDeformerAtIndex = function (deformer, index) {
        deformer._deformerStack = this;
        this._deformers.splice(index, 0, deformer);
    };
    /* Remove a deformer. */
    DeformerStack.prototype.removeDeformer = function (deformer) {
        var index = this._deformers.indexOf(deformer);
        if (index >= 0) {
            this._deformers.splice(index, 1);
        }
        this.emit('deformerRemoved');
    };
    DeformerStack.prototype.moveDeformerToIndex = function (deformer, index) {
        this.removeDeformer(deformer);
        this.addDeformerAtIndex(deformer, index);
    };
    // TODO: we'll need to split this in vertex and fragment parts
    DeformerStack.prototype.deformerIndex = function (deformer) {
        return this._deformers.indexOf(deformer);
    };
    /* Remove all deformers. */
    DeformerStack.prototype.removeAllDeformers = function () {
        while (this.hasDeformers) {
            this.removeDeformer(this.deformers[0]);
        }
    };
    Object.defineProperty(DeformerStack.prototype, "hasDeformers", {
        get: function () {
            return this.deformers.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    DeformerStack.prototype._combineUniforms = function () {
        var deformers = this.deformers.filter(function (deformer) { return deformer.enabled; });
        var uniforms = Object.assign.apply(Object, __spreadArray([{}], deformers.map(function (deformer) { return deformer._uniforms(); }), false));
        return uniforms;
    };
    // append src since this returns the source code for the shader
    DeformerStack.prototype._buildVertexShader = function () {
        var deformers = this.deformers.filter(function (deformer) { return deformer.enabled; });
        return this._combineVertexHeaders(deformers) + '\n\n' + this._combineVertexBodies(deformers);
    };
    // append src since this returns the source code for the shader
    DeformerStack.prototype._buildFragmentShader = function () {
        var deformers = this.deformers.filter(function (deformer) { return deformer.enabled; });
        return this._combineFragmentHeaders(deformers) + '\n\n' + this._combineFragmentBodies(deformers);
    };
    DeformerStack.prototype._combineFragmentHeaders = function (deformers) {
        var combinedDeformerHeaders = '';
        deformers.forEach(function (deformer) {
            combinedDeformerHeaders += "".concat(deformer._fragmentHeader(), "\n");
        });
        var uvHeaders = '';
        if (this.uvs) {
            uvHeaders = "\n            varying vec2 vUvs;\n            uniform sampler2D uSampler2;";
        }
        return this._reformatHeaderSnippet("\n        ".concat(combinedDeformerHeaders, "\n        ").concat(uvHeaders, "\n        uniform vec4 uColor;"));
    };
    DeformerStack.prototype._combineFragmentBodies = function (deformers) {
        var aggregateFunctions = '';
        deformers.forEach(function (deformer) {
            aggregateFunctions += "".concat(deformer._fragBody(), "\n");
        });
        // uv
        var mainUVFunction = '';
        if (this.uvs) {
            mainUVFunction = "vec2 uv0 = vUvs;\n";
            var lastUVIndex_1 = 0;
            deformers
                .filter(function (deformer) { return deformer.enabled && deformer.deformerType.includes(DEFORMER_MANIP_ENUM.UV); })
                .forEach(function (deformer, index) {
                mainUVFunction += "vec2 uv".concat(index + 1, " = getUV").concat(deformer.index, "(uv").concat(index, ");\n");
                lastUVIndex_1 = index + 1;
            });
            mainUVFunction += "vec4 ocolor = texture2D(uSampler2, uv".concat(lastUVIndex_1, ");");
        }
        else {
            mainUVFunction = "vec4 ocolor = uColor;";
        }
        // color
        var mainColorFunction = "vec4 color0 = uColor;\n";
        var lastColorIndex = 0;
        deformers
            .filter(function (deformer) { return deformer.enabled && deformer.deformerType.includes(DEFORMER_MANIP_ENUM.COLOR); })
            .forEach(function (deformer, index) {
            mainColorFunction += "vec4 color".concat(index + 1, " = getColor").concat(deformer.index, "(color").concat(index, ");\n");
            lastColorIndex = index + 1;
        });
        // final
        var mainFunction = "gl_FragColor = ocolor * color".concat(lastColorIndex, ";");
        // main
        return this._reformatBodySnippet("\n        ".concat(aggregateFunctions, "\n        void main() {\n            ").concat(mainUVFunction, "\n            ").concat(mainColorFunction, "\n            ").concat(mainFunction, "\n        }"));
    };
    DeformerStack.prototype._reformatHeaderSnippet = function (snippet) {
        return snippet
            .split(/\r?\n/)
            .map(function (item) { return item.trim(); })
            .filter(function (item) { return item.length > 0; })
            .sort()
            .join('\n');
    };
    DeformerStack.prototype._reformatBodySnippet = function (snippet) {
        var lines = snippet
            .split(/\r?\n/)
            .map(function (item) { return item.trim(); })
            .filter(function (item) { return item.length > 0; });
        var indent = 0;
        for (var i = 0; i < lines.length; i++) {
            var prefix = '';
            if (lines[i].includes('void main(') || (lines[i].includes('get') && lines[i].includes('{'))) {
                indent += 1;
                continue;
            }
            if (lines[i].includes('}')) {
                indent -= 1;
            }
            if (indent > 0) {
                prefix = Array(indent + 1).join('\t');
            }
            if (lines[i].includes('if') || lines[i].includes('else')) {
                indent += 1;
            }
            lines[i] = prefix + lines[i];
        }
        return lines.join('\n');
    };
    DeformerStack.prototype._combineVertexHeaders = function (deformers) {
        var hasWeight = false;
        var combineDeformerHeaders = '';
        deformers.forEach(function (deformer) {
            // TODO: this is really just visual cleanup -- we don't really need this...
            var lines = deformer._vertexHeader()
                .split(/\r?\n/)
                .map(function (item) { return item.trim(); })
                .filter(function (item) { return item.length > 0; });
            // TODO: warning, this assumes every deformer uses the same transform type!!!
            //  we probably want to make this variable
            lines.forEach(function (line) {
                // remove possible duplicate aWeight
                if (line.includes('aWeight')) {
                    if (hasWeight) {
                        return;
                    }
                    hasWeight = true;
                }
                combineDeformerHeaders += "".concat(line, "\n");
            });
        });
        var uvHeaders = '';
        if (this.uvs) {
            uvHeaders = "\n            attribute vec2 aUvs;\n            varying vec2 vUvs;";
        }
        return this._reformatHeaderSnippet("\n        attribute vec2 aVertexPosition;\n        uniform mat3 projectionMatrix;\n        uniform mat3 translationMatrix;\n        ".concat(uvHeaders, "\n        ").concat(combineDeformerHeaders, "\n        "));
    };
    DeformerStack.prototype.logAssembly = function () {
        console.log('WARNING: this not necessarily the source the current compiled shader used! This only shows the current source. Re-compile the shader if something doesn\'t match your expectation.');
        console.log('uniforms', __assign({ 
            // uSampler2: this._parent.atlas.texture[0],
            uColor: this._parent.color }, this._combineUniforms()));
        console.log('vertex', this._buildVertexShader());
        console.log('fragment', this._buildFragmentShader());
    };
    DeformerStack.prototype._combineVertexBodies = function (deformers) {
        // the matrix or vertex computation function for each deformer.
        // these methods are going to be called within the main function.
        var combineFunctions = '';
        deformers.forEach(function (deformer) {
            combineFunctions += "".concat(deformer._vertBody(), "\n");
        });
        // blocks of code which execute compute a matrix or vertex deformer function and contribute to the final vertex position
        var callFunctions = "vec3 vertexPosition0 = vec3(aVertexPosition.xy, 1.0);\n";
        var lastIndex = 0;
        deformers
            .filter(function (deformer) { return deformer.deformerType.includes(DEFORMER_MANIP_ENUM.MATRIX) || deformer.deformerType.includes(DEFORMER_MANIP_ENUM.VERTEX); })
            .forEach(function (deformer, index) {
            VERBOSE && console.log('deformer', index, deformer.deformerType);
            if (deformer.deformerType.includes(DEFORMER_MANIP_ENUM.MATRIX)) {
                callFunctions += "vec3 vertexPosition".concat(index + 1, " = getTranslationMatrix").concat(deformer.index, "() * vertexPosition").concat(index, ";\n");
                lastIndex = index + 1;
            }
            if (deformer.deformerType.includes(DEFORMER_MANIP_ENUM.VERTEX)) {
                callFunctions += "vec3 vertexPosition".concat(index + 1, " = getVertexPosition").concat(deformer.index, "(vertexPosition").concat(index, ");\n");
                lastIndex = index + 1;
            }
        });
        callFunctions += "vec3 finalPosition = vec3(projectionMatrix * translationMatrix * vertexPosition".concat(lastIndex, ");\n");
        // blocks of code which prepare the varying variables for the fragment shader
        var varyingUVCodeBlock = '';
        if (this.uvs) {
            varyingUVCodeBlock = "vUvs = aUvs;";
        }
        var varyingCodeBlocks = '';
        deformers.forEach(function (deformer) {
            varyingCodeBlocks += "".concat(deformer._vertexMain(), "\n");
        });
        return this._reformatBodySnippet("\n        ".concat(combineFunctions, "\n        void main(void) {\n            ").concat(callFunctions, "\n            gl_Position = vec4(finalPosition.xy, 0.0, 1.0);\n            ").concat(varyingCodeBlocks, "\n            ").concat(varyingUVCodeBlock, "\n        }"));
    };
    return DeformerStack;
}(PIXI.utils.EventEmitter));
export { DeformerStack };
